<template>
    <div class="knowledgDetail">
        <loadings v-if="loading"></loadings>
        <template v-else>
            <headers :title="title"></headers>
            <div class="knowledg">
                <div class="con">
                    <p>{{knowledg.name}}</p>
                    <div>知识点掌握率{{knowledg.k_right_rate}}%</div>
                </div>
            </div>
            <h3 class="title">该知识点包含以下题目</h3>
            <template v-if="knowledg.relate_question_info.length">
                <mathCom :questions="knowledg.relate_question_info"
                         :type="'knowledg'"
                         :showNum="true"
                         :sid="sid"
                         v-if="sid==21||sid==22"></mathCom>
                <chinese :questions="knowledg.relate_question_info"
                         :type="'knowledg'"
                         :showNum="true"
                         :sid="sid"
                         v-else></chinese>
            </template>
            <noResouse :text="'暂无试题'"
                       v-else></noResouse>
        </template>
    </div>
</template>

<script>
import headers from "COMPONENTS/base/header.vue";
import loadings from "COMPONENTS/base/loadingS.vue";
import chinese from "./chinese/wrong.vue";
import mathCom from "./math/wrong.vue";
import noResouse from 'COMPONENTS/noResouse.vue';
export default {
    components: {
        loadings,
        noResouse,
        headers,
        chinese,
        mathCom,
    },
    data () {
        return {
            title: "知识点掌握情况",
            question: [],
            sid: this.$route.query.sid,
            loading: false,
            knowledg: JSON.parse(localStorage.getItem('teaTaskKnowledg')),
        }
    },
    created () {
        //console.log(this.knowledg)

    },
    mounted () {
        this.$nextTick(function () {
            MathJax.Hub.Typeset(document.body)
        })
    },
    methods: {}
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.knowledgDetail {
    margin-bottom: 30px / $ppr;
}
.knowledg {
    margin-top: 30px / $ppr;
    .con {
        width: 600px / $ppr;
        padding: 24px / $ppr 30px / $ppr;
        background: #fff;
        border-radius: 16px / $ppr;
        margin: 0 auto 30px / $ppr;
        line-height: 48px / $ppr;
        font-size: 28px / $ppr;
        p {
            line-height: 48px / $ppr;
        }
        div {
            color: #999;
            font-size: 24px / $ppr;
            line-height: 48px / $ppr;
            padding-top: 10px / $ppr;
        }
    }
}
.title {
    line-height: 60px / $ppr;
    font-size: 30px / $ppr;
    color: #3c7cfb;
    width: 660px / $ppr;
    margin: 0 auto;
}
</style>